import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@/shared/ui';

import { STORAGE_FULL_THRESHOLD } from '../config';

type UseStorageBlockedTooltipProps = {
  isStorageBlocked: boolean;
  triggerClassName?: string;
};

export const useStorageBlockedTooltip = (
  props: UseStorageBlockedTooltipProps,
) => {
  const { isStorageBlocked, triggerClassName } = props;
  const { formatMessage } = useIntl();

  const wrapWithStorageTooltip = (element: ReactElement) => {
    if (isStorageBlocked) {
      return (
        <Tooltip.Primary
          triggerClassName={triggerClassName}
          content={formatMessage(
            {
              id: 'storage.warningMessage',
              defaultMessage:
                "You've reached {percentage}% of your storage limit. Please contact your sales manager to extend the limit.",
            },
            { percentage: STORAGE_FULL_THRESHOLD },
          )}
        >
          {element}
        </Tooltip.Primary>
      );
    }

    return element;
  };

  return { wrapWithStorageTooltip };
};
